import gql from "graphql-tag"
import config from '~/config'

export default gql`
  query participant ($id: MongoID!) {
    participant(_id: $id){
      _id
      eventId
      userId
      remarks
      profile {
        _id
        prefix
        postalCode
        imageUrl
        nationalId
        gender
        nationality
        firstName
        lastName
        email
        weight
        height
        telephone
        club
        birthDate
        healthIssues
        allergies
        bloodType
        consent
        imageValidation {
          valid
          errors
        }
        emergencyContact {
          name
          relationship
          phone
        }
        street
        locality
        city
        country
        province
        taxInvoice {
          type
          taxId
          address
          name
          _id
        }
        receipt {
          type
          taxId
          address
          name
          _id
        }
        address {
          region
          locality
          country
          postalCode
        }
      }
      eventId
      registrationId
      order
      createdByUserId
      event {
        _id
        isLineLogin
        ticketGroups {
          _id
          backgroundColor
          order
          hidden
          name {
            ${config.locale_list}
          }
        }
        ticketQuestions {
          _id
          kind
          masterKind
          inputType
          order
          name {
            ${config.locale_list}
          }
          opts
          items {
            _id
            imageUrl
            value {
              ${config.locale_list}
            }
          }
        }
        ticketTypes {
          _id
          group
          groupId
          price
          shirtEnabled
          finisherShirtEnabled
          shirtTypeIds
          shirtIds
          finisherShirtTypeIds
          finisherShirtIds
          name {
            ${config.locale_list}
          }
          participantFields {
            _id
            name
            enabled
            required
          }
          race {
            _id
            name {
              ${config.locale_list}
            }
            distance
          }
          questions {
            _id
            kind
            masterKind
            inputType
            shirtTypeIds
            required
            order
            name {
              ${config.locale_list}
            }
            condition {
              _id
              questionId
              operator
              value
            }
            opts
            items {
              _id
              imageUrl
              value {
                ${config.locale_list}
              }
            }
          }
        }
        settings {
          _id
          ticket {
            _id
            numberDigits
          }
          participant {
            _id
            uniqueNationalId
            uniqueEmail
            fields {
              _id
              name
              enabled
              required
              extraMessage {
                ${config.locale_list}
              }
              validations {
                _id
                type
                params
                message {
                  ${config.locale_list}
                }
              }
            }
          }
          virtualRun {
            _id
            fields {
              _id
              enabled
              required
            }
            period {
              start
              end
              _id
            }
            isAutoApproved
            isOCREnabled
            isTime
            raceTeam
            distanceMode
            donationPerDistance
            maxDonation
            baseDonation
            noEcer
            ecerV2
            isMultiRace
            finisherwall
            splitRaces
            distanceLimit
            virtualRunMessage
            chartsMode
            limitSubmit
            _id
          }
          payment {
            currency
          }
        }
        shirts {
          _id
          shirtTypeId
          name {
            ${config.locale_list}
          }
        }
        finisherShirts {
          _id
          shirtTypeId
          name {
            ${config.locale_list}
          }
        }
        shirtCounts {
          _id
          shirtTypeId
          quantity
          count
          name {
            en
            th
          }
        }
        shirtTypes {
          _id
          imageUrl
          name {
            ${config.locale_list}
          }
        }
        finisherShirtTypes {
          _id
          imageUrl
          name {
            ${config.locale_list}
          }
        }
      }
      registration {
        _id
        status
        registrationType {
          _id
          ticketTypeIds
        }
      }
      tickets {
        _id
        externalCouponCode
        eBib {
          profile {
            url
            top
            left
            width
            height
            zoom
          }
        }
        eCer {
          profile {
            url
            top
            left
            width
            height
            zoom
          }
        }
        reservedNumber
        number
        eventCode
        productTypeId
        eventId
        registrationId
        participantId
        nameOnBib
        couponCodeText
        couponCodeId
        shirtTypeId
        shirtId
        finisherShirtTypeId
        finisherShirtId
        kind
        remarks
        delivery
        trackingCode
        deliveryCarrier
        deliverTo {
          recipient
          street
          city
          country
          locality
          region
          postalCode
        }
        cancelRequest {
          _id
          status
          method {
            _id
            name {
              en
              th
              zh
            }
          }
          response {
            _id
          }
        }
        ticketType {
          _id
          group
          groupId
          externalCoupon {
            type
          }
          ticketGroup {
            _id
            backgroundColor
            name {
              ${config.locale_list}
            }
            hidden
          }
          price
          deliveryOption
          deliveryPrice
          shirtEnabled
          finisherShirtEnabled
          quantity
          name {
            ${config.locale_list}
          }
          participantFields {
            _id
            name
            enabled
            required
            extraMessage {
              ${config.locale_list}
            }
            validations {
              type
              params
              message {
                ${config.locale_list}
              }
            }
          }
          eBibEnabled
          eBib {
            _id
            name
            eventId
            nameOnBib
            bibNumber
            fonts {
              fontFamily
              fontSrcUrl
            }
            nameField
            backgroundUrl
            profileEnabled
            profilePosition
            profile {
              url
              top
              left
              width
              height
              zoom
            }
            numberStyle {
              font
              textAlign
              fillStyle
              top
              left
              fontSize
            }
            nameStyle {
              font
              textAlign
              fillStyle
              top
              left
              fontSize
            }
          }
          virtualBib {
            _id
            backgroundUrl
            nameField
            fonts {
              _id
              fontFamily
              fontSrcUrl
            }
            numberStyle {
              _id
              font
              textAlign
              fillStyle
              top
              left
            }
            nameStyle {
              _id
              font
              textAlign
              fillStyle
              top
              left
            }
          }
          race {
            _id
            name {
              en
              th
              zh
            }
            eCer {
              _id
              name
              eventId
              nameOnBib
              bibNumber
              totalDistance
              totalDistanceUnit
              submittedCount
              totalDistanceEnabled
              submittedCountEnabled
              totalDistanceStyle {
                font
                textAlign
                fillStyle
                top
                left
                fontSize
              }
              submittedCountStyle {
                font
                textAlign
                fillStyle
                top
                left
                fontSize
              }
              fonts {
                fontFamily
                fontSrcUrl
              }
              nameField
              backgroundUrl
              profileEnabled
              profilePosition
              numberStyle {
                font
                textAlign
                fillStyle
                top
                left
                fontSize
              }
              nameStyle {
                font
                textAlign
                fillStyle
                top
                left
                fontSize
              }
              profile {
                url
                top
                left
                width
                height
                zoom
              }
            }
            distance
            distanceUnit
            startTime
            ageCategoryDiff
            ageRangeStrict {
              male {
                min
                max
              }
              female {
                min
                max
              }
              lgbtq {
                min
                max
              }
            }
            ageCategories {
              _id
              min
              max
              gender
            }
          }
          questions {
            _id
            kind
            masterKind
            inputType
            default
            shirtTypeIds
            order
            required
            name {
              en
              th
              zh
            }
            opts
            items {
              _id
              imageUrl
              value {
                en
                th
                zh
              }
            }
          }
        }
        options (sort: ORDER_ASC) {
          _id
          value
          order
          itemId
          itemIds
          shirtId
          shirtTypeId
          questionId
          question {
            _id
            kind
            inputType
            shirtTypeIds
            order
            name {
              en
              th
              zh
            }
            condition {
              _id
              questionId
              operator
              value
            }
            items {
              _id
              imageUrl
              value {
                en
                th
                zh
              }
            }
          }
        }
      }
    }
  }
`